import { render, staticRenderFns } from "./UserPageServerError.vue?vue&type=template&id=77fbe970&scoped=true&"
import script from "./UserPageServerError.vue?vue&type=script&lang=js&"
export * from "./UserPageServerError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fbe970",
  null
  
)

export default component.exports